import styled from 'styled-components';

const DesktopOnly = styled.div `
  @media screen and (max-width: ${({ breakpoint, theme }) => breakpoint !== null && breakpoint !== void 0 ? breakpoint : theme.breakpoints.lg}) {
    display: none;
  }
`;

export { DesktopOnly as default };
//# sourceMappingURL=DesktopOnly.mjs.map
